// Official Janté Lux Hotels logo — replaces the old TulipMark SVG.
export default function JanteLogo({ size = 28, className = "", alt = "Janté Lux Hotels" }) {
  return (
    <img
      src="https://customer-assets.emergentagent.com/job_sasha-host-flow/artifacts/bshpfhe5_Jante%20Lux%20Hotel%202.png"
      alt={alt}
      width={size}
      height={size * 1.4}
      style={{ height: size * 1.4, width: "auto" }}
      className={`object-contain ${className}`}
    />
  );
}
